import { useMutation, useQuery } from '@apollo/client';
import { SERVICES_QUERY, BOOK_SERVICE_MUTATION } from '../gql/appointments.gql';
import { SET_SERVICE_ACTIVE_MUTATION, UPSERT_SERVICE_MUTATION } from '../gql/appointments.management.gql';

// Backwards-compatibility re-exports for modules that still import operations from this file
// e.g., flowBeheer/appointments/* importing { SERVICES_QUERY } from '../../service/useAppointmentGraphQL'
export { SERVICES_QUERY } from '../gql/appointments.gql';

export function useAppointmentGraphQL() {
    const useServices = (active /* Boolean | null | undefined */) => {
        const variables = {};
        if (active === true || active === false) variables.active = active;
        else variables.active = null; // omit or null per backend tolerance
        return useQuery(SERVICES_QUERY, { variables });
    };
    // Backwards-compatible alias used by AppointmentServiceStep/TimeslotStep
    const useActiveServices = () => useQuery(SERVICES_QUERY, { variables: { active: true } });
    const useBookService = () => useMutation(BOOK_SERVICE_MUTATION);
    return { useServices, useActiveServices, useBookService };
}

export function useAppointmentManagementGraphQL() {
    const useSetServiceActive = () => useMutation(SET_SERVICE_ACTIVE_MUTATION);
    const useUpsertService = () => useMutation(UPSERT_SERVICE_MUTATION);
    return { useSetServiceActive, useUpsertService };
}
